export const customDate = (data)=>{
    const date = new Date(data);
    return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
}

export const getAcademicYear = () => {
  const now = new Date();
  const year = now.getFullYear();
  const nextYear = (year + 1).toString().slice(-2);

  return `${year}${nextYear}`;
};
